<template>
  <div
    class="pt-5 p-st"
  >
    <div
      class="container"
      data-aos="fade"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      <div class="row align-items-center text-center">
        <!-- <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 text-center">
          <img :src="picture" />
        </div> -->
        <!-- <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pt-5"> -->
          <div class="col-xl-12 col-bg-12 col-md-12 col-sm-12 pt-5 d-flex flex-column justify-content-center align-items-center ">

            
          <!-- <p class="text-main">HEY! I AM</p> -->
          <span
            class="text-main-centre text-white"
            >A Passionate</span>
            <span
            class="text-main-centre text-yellow "
            >Front End Developer</span>
            <div class="typewriter text-white ">
           <!-- <span>Software Developer </span> -->
          </div>
          <div>
            <p class="text-center text-white" v-html="description"></p>
          </div>
          <div class="text-center pb-4">
            <button
              class="btn btn-outline-secondary mx-2 "
              @click="open('linkedin')"
              v-tooltip.bottom="'LinkedIn'"
            >
              <i class="fab fa-linkedin"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('github')"
              v-tooltip.bottom="'GitHub'"
            >
              <i class="fab fa-github"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('gitlab')"
              v-tooltip.bottom="'Gitlab'"
            >
              <i class="fab fa-gitlab"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('resume')"
              v-tooltip.bottom="'Resume'"
            >
              <i class="fa fa-file"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

import Wave from "./helpers/Wave";

export default {
  name: "Home",
  components: {
    Wave,
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: info.name,
      linkedin: info.links.linkedin,
      github: info.links.github,
      gitlab: info.links.gitlab,
      resume: info.links.resume
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "gitlab":
          window.open(this.gitlab, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.home-title {
  font-size: 45px;
  font-weight: 600;
}

.bg-background {
background-color: #090F16;
}

.text-main-centre {
    font-size: 70px;
    font-weight: 700;
}

.text-yellow {
 color : #FECD87;
}

img {
  max-width: 450px;
  margin-top: 20px;
  margin-bottom: 100px;
  transform: rotateY(180deg);
}

@media only screen and (max-width: 580px) {
  img {
    object-fit: cover;
    border-radius: 50%;
    height: 200px;
    width: 200px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 2px solid rgb(205, 205, 205);
  }
}

.fa {
  font-size: 15px;
}

.btn {
  border-color: #669db3ff;
  color: #669db3ff;
}

.btn:hover {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}

.btn:focus {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}

.btn:focus {
  outline: none !important;
}

p {
  text-align: justify;
  font-weight: 400;
}

p.text-main {
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    color: #90acd1;
    letter-spacing: 4px;
}

.typewriter span {
    color: #e45447;
    font-weight: 600;
    font-size: 20px;
    line-height: 42px;
    margin-bottom: 10px;
    overflow: hidden; /* Ensures the content is not revealed until the animation */
    border-right: .15em solid orange; /* The typwriter cursor */
    white-space: nowrap; 
    margin-top: 4px; /* Gives that scrolling effect as the typing happens */
    letter-spacing: .10em; /* Adjust as needed */
    animation: 
    typing 3.5s steps(40, end),
    blink-caret .75s step-end infinite;
}


/* The typing effect */
@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange; }
}

/* LEAVES */
</style>
